// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const muk: PokeData = {
  "id": 89,
  "name": "muk",
  "height": 12,
  "weight": 300,
  "base_experience": 175,
  "types": [
    PokeType.POISON
  ],
  "api_moves": [
    "pound",
    "disable",
    "toxic",
    "screech",
    "harden",
    "minimize",
    "haze",
    "smog",
    "sludge",
    "poison-gas",
    "acid-armor",
    "sludge-bomb",
    "mud-slap",
    "memento",
    "mud-shot",
    "fling",
    "mud-bomb",
    "gunk-shot",
    "sludge-wave",
    "belch",
    "moonblast",
    "venom-drench"
  ],
  "moves": [
    "poison-gas",
    "sludge-bomb",
    "mud-slap",
    "mud-shot",
    "mud-bomb",
    "moonblast",
    "venom-drench",
    "purify",
    "mortal-gas",
    "toxic-spikes",
    "poison-fang",
    "poison-jab",
    "toxic-overload"
  ],
  "evolution_chain": {
    "id": 38,
    "item": null,
    "species": [
      {
        "name": "grimer",
        "order": 96,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "muk",
        "order": 97,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": 88,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 38,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 153,
    "speed": 80,
    "ability_power": 167
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
